<template>
  <div class="carousel-container">
    <div class="carousel-container-content">
      <div class="slide-container">
        <!-- 预加载大的banner图片 -->
        <div class="hidden-image-cache">
          <img v-for="(item, index) in items" :src="item.config.backgroundImageUrl" :key="index">
        </div>
        <div class="slide-item slide-background" :style="{backgroundImage: 'url(' + item.config.backgroundImageUrl + ')'}"  v-for="(item, index) in items" :class="{'slide-item-display': index === current}" :key="index">
          <!-- <div class="slide-background" :style="{backgroundImage: 'url(' + item.config.backgroundImageUrl + ')'}"></div> -->
          <div v-if="item.config.imageFlag" class="slide-image" @click="actionPerform(item)"></div>
          <div v-else-if="!item.config.videoFlag" class="slide-text-info">
            <div class="slide-text-container" :class="{'container-kv': item.config.buttonKV}" >
              <div v-if="item.template === 'default'" class="template-default">
                <div class="slide-title" :class="{'special-color-title' : item.config.color}">
                  {{item.config.title}}<br/>
                  {{item.config.title1}}
                </div>
                <div class="slide-desc" :class="{'special-color-desc': item.config.color}">
                  {{item.config.desc1}}<br>
                  {{item.config.desc2}}<br>
                  {{item.config.desc3}}
                </div>
                <div class="slide-img" v-if="item.config.contentImageUrl" :style="{backgroundImage:'url(' + item.config.contentImageUrl + ')'}"></div>
              </div>
              <div class="button-group" v-if="item.config.millionFace">
                <div class="slide-action1" @click="$router.transfer(item.actionTransferUrl)">{{'立即体验'}}</div>
                <div class="slide-action2" @click="actionPerform(item)">{{'联系我们'}}</div>
              </div>
              <div class="slide-action" v-else :class="{'special-color-action' : item.config.color, 'special-position': item.config.contentImageUrl, 'button-kv': item.config.buttonKV, 'special-position-two': item.config.set}" @click="actionPerform(item)">{{item.config.buttonText || '了解详情'}}</div>
            </div>
          </div>
          <div class="video-page-box" v-else>
            <div class="video-page-title">腾讯优图</div>
            <div class="video-play-btn" @click="showVideo" >播放按钮</div>
          </div>
        </div>
        <div class="control-container-box">
          <div class="control-container">
            <div class="slide-control-dot" v-for="(item, index) in items" :class="{'current-dot': current === index}" @click="switchSlide(index)" :key="index"></div>
          </div>
        </div>
      </div>
      <ApplyMillion :dialogVisible.sync="millionFaceDialogVisible" @close="handleCloseDialog"/>
    </div>
    <div class="bannner-video" :class="{'showVideo': videoFlag}">
      <div class="video-box">
        <div class="video-close" @click="closeVideo"></div>
        <video class="player" controls="" ref="youtuHomeVideo">
          <source type="video/mp4" src="/static/files/mp4file/youtu_new_intro.mp4">
        </video>
      </div>
    </div>
  </div>
</template>
<script>
import ApplyMillion from './ApplyMillion';

const BANNERNUM = 5;
export default {
  name: 'SimpleCarousel',
  props: {
    items: Array
  },
  components: {
    ApplyMillion
  },
  data() {
    return {
      current: 0,
      timerTask: null,
      millionFaceDialogVisible: false,
      videoFlag: false
    };
  },
  methods: {
    switchSlide(index) {
      if (index === this.current) {
        return;
      }
      if (index >= this.items.length) {
        index = 0;
      }
      this.timerTask.release();
      this.current = index;
      this.timerTask = this.$timer.once(this.switchNextSlide, 5000);
    },
    switchNextSlide() {
      this.switchSlide(this.current + 1);
    },
    actionPerform(item) {
      if (item.actionPerform) {
        item.actionPerform();
        return;
      }
      if (item.newWeb) {
        window.open(item.actionTransferUrl, '_blank');
        return;
      }
      if (item.millionFace) {
        this.millionFaceDialogVisible = true;
        return;
      }
      if (item.actionTransferUrl) {
        this.$router.transfer(item.actionTransferUrl);
        return;
      }
      this.$emit('action', item);
    },
    handleCloseDialog() {
      this.millionFaceDialogVisible = false;
    },
    showVideo() {
      if (this.current === (BANNERNUM - 1)) {
        this.videoFlag = true;
      }
    },
    closeVideo() {
      this.$refs.youtuHomeVideo.pause();
      this.videoFlag = false;
    }
  },
  created() {
    this.switchNextSlide = this.switchNextSlide.bind(this);
    this.timerTask = this.$timer.once(this.switchNextSlide, 5000);
  }
};
</script>
<style lang="less" scoped>
@slide-height: 450px;
.carousel-container {
  height: @slide-height;
  font-size: 0;
  background-color: #F5F3F7;
  position: relative;
  .carousel-container-content {
    height: 100%;
    margin: 55px auto 0;
    position: relative;
    .slide-container {
      height: 100%;
      overflow: hidden;
      .hidden-image-cache {
        height: 0px;
        width: 0px;
        overflow: hidden;
      }
      .slide-item {
        width: 100%;
        /* height: 500px; */
        position: relative;
        display: none;
        &.slide-item-display {
          display: block;
        }
        &.slide-background {
          height: 100%;
          width: 100%;
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
        }
        .slide-image {
          width: 100%;
          height: 100%;
          &:hover {
            cursor: pointer;
          }
        }
        .slide-text-info {
          width: 1263px;
          height: 300px;
          margin: 0 auto;
          padding-top: 80px;
          .slide-text-container {
            font-size: 18px;
            padding: 0 10px;
            .template-default {
              position: relative;
              .slide-title {
                font-size: 40px;
                font-family: 'PingFangSC-Medium';
                line-height: 59px;
                font-weight: 500;
                color: #000000;
              }
              .slide-desc {
                line-height: 30px;
                font-size: 18px;
                padding-top: 15px;
                color: #3D485D;
                text-align: justify;
                /* &.special-color-desc{
                  color: #333333;
                } */
              }
              .slide-img {
                position: absolute;
                top: 104px;
                left: 0;
                width: 100%;
                height: 70px;
                background-repeat: no-repeat;
                background-position: bottom left;
              }
              &.million-face-template {
                .slide-title {
                  margin-top: 100px;
                  text-align: center;
                  letter-spacing: 0px;
                }
              }
            }
            .slide-action {
              cursor: pointer;
              box-sizing: border-box;
              width: 140px;
              height: 40px;
              margin-top: 30px;
              padding-left: 32px;
              background-image: url(./img/arrow_white.svg);
              background-repeat: no-repeat;
              background-size: 20px;
              background-position: 100px center;
              font-size: 14px;
              background-color: #0080FF;
              color: #ffffff;
              line-height: 40px;
              font-family: 'PingFangSC-Semibold';
              font-weight: 600;
              &:hover {
                /* background-color: rgba(255,255,255,0.25); */
                background-color: #198CFF;
              }
              &.special-color-action{
                bottom: 10px;
                border: 2px solid #7e7e7e;
                color: #7e7e7e;
                &:hover {
                  background-color: rgba(126,126,126,0.3);
                  color: #666666;
                }
              }
              &.special-position {
                bottom: -40px;
              }
              &.button-kv {
                margin: 107px 0 0 480px;
                border: none;
                &:hover {
                  background-color: rgba(126,126,126,0);
                }
              }
              &.special-position-two {
                margin: 100px auto;
              }
            }
            .button-group {
              margin: -60px 0;
              width: 360px;
              .slide-action1, .slide-action2 {
                cursor: pointer;
                display: inline-block;
                width: 140px;
                height: 40px;
                box-sizing: border-box;
                color: #ffffff;
                border: 2px solid #ffffff;
                font-size: 16px;
                text-align: center;
                line-height: 40px;
                &:hover {
                  background-color: rgba(255,255,255,0.2);
                }
              }
              .slide-action1 {
                margin: 0;
              }
              .slide-action2 {
                margin: 20px;
              }
            }
            &.container-kv {
              height: 300px;
            }
          }
        }
        .video-page-box {
          width: 100%;
          height: 150px;
          position: absolute;
          top: 145px;
          .video-page-title {
            width: 170px;
            height: 59px;
            font-size: 40px;
            font-family: 'PingFangSC-Medium';
            line-height: 59px;
            font-weight: 500;
            color: #ffffff;
            margin: 0 auto;
          }
          .video-play-btn {
            width: 60px;
            height: 60px;
            margin: 30px auto 0;
            background: url("./img/icon_play_normal.svg") center center no-repeat;
            &:hover {
              cursor: pointer;
              background: url("./img/icon_play_hover.svg") center center no-repeat;
            }
          }
        }
      }
      .control-container-box {
        width: 1263px;
        margin: 0 auto;
        position: relative;
        .control-container {
          position: absolute;
          width: 100%;
          height: 20px;
          bottom: 20px;
          left: 0;
          /* text-align: center; */
          .slide-control-dot {
            z-index: 100;
            display: inline-block;
            width: 30px;
            height: 2px;
            /* border-radius: 5px; */
            /* border: 1px solid #ffffff; */
            margin: 5px 9px;
            cursor: pointer;
            background-color: #ffffff;
            &.current-dot {
              background-color:  #0080FF;
              cursor: default;
            }
          }
        }
      }
    }
  }
  .bannner-video {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    font-size: 18px;
    background: rgba(0,0,0,0.30);
    display: none;
    .video-box {
      position: relative;
      width: 800px;
      height: 450px;
      box-shadow: 8px 8px 20px 0px rgba(0,47,73,0.1);
      .player {
        width: 800px;
        height: 450px;
      }
      .video-close {
        width: 40px;
        height: 40px;
        opacity: 0.6;
        background: url('./img/icon_close_white.svg') center center no-repeat;
        border: 1px solid rgba(255,255,255,1);
        position: absolute;
        right: -50px;
        top: -50px;
        z-index: 1000;
        cursor: pointer;
        &:hover {
          cursor: pointer;
          background: url('./img/icon_close_blue.svg') center center no-repeat;
          background-color: #ffffff;
          opacity: 0.8;
        }
      }
    }
  }
  .showVideo {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/common/SimpleCarousel.vue